export const DefaultShadowRenderingIncrement = 1;

/**
 * Maximum amount of time we can spend while shadow rendering for each increment.
 * 30ms because frames longer than 50ms are considered long frames. 20ms is the buffer.
 *
 */
export const MaxTimeForEachIncrement = 30;

/**
 * Computes the next shadow rendering increment by measuring the total time it has taken to render
 * current set of items and making sure there will be no long frames.
 */
export function computeNextShadowRenderingIncrement(
  totalTimeUntilNow: number,
  itemsRendered: number
): number {
  if (totalTimeUntilNow > 0 && itemsRendered > 0) {
    const nextIncrement =
      MaxTimeForEachIncrement * (itemsRendered / totalTimeUntilNow);
    if (nextIncrement > DefaultShadowRenderingIncrement) {
      return Math.floor(nextIncrement);
    }
  }

  return DefaultShadowRenderingIncrement;
}
